<template>

<div class="recomment-tem-commentbox">
        <div class="comment-tem-left">
            <div class="articletx">
                <img @click="gotootherdynamic" :data-otherrenid="item.reply_uid" :src="item.reply_avatar_url" />
            </div>
        </div>
        <div class="comment-tem-right">
            <div class="article-r-top">
                <div class="article-title">
                    <div class="article-author">{{item.reply_name}}</div>
                    <img  class='article-to' src='http://www.wodegame.com/tg/xianpipa/images/dynamic_icon_play.png' />
                    <div class="article-author">{{item.to_name}}</div>          
                </div>
            </div>
            <div class="article-content">
                <div class="article-content-text" @click="upCommentbigchild" :data-toname="item.reply_name" :data-cid="item.cid" :data-uid="item.to_uid" :data-name="item.reply_name" id="article-content-text">{{item.content}}</div>
                <div class="comment-imgbox" v-if="item.content_extra.length>0">
                    <div class="comment-imgbox-nr"><img :src="item.content_extra" @click="showImg" :data-imgurl="item.content_extra" 
                data-imgidx="0"/></div>
                </div>     

            </div>
            <div class="article-echo">                
                <div class="comment-tem-dianping">
                    <div class="article-echo-cell comment-tem-applause" @click="dianzanbtn002" :data-index="index" :data-cid="item.cid" :data-rid="item.id" :data-idx="idx">
                        <div v-if="item.is_nice == 1">
                            <span class="red">{{item.nices_num}}</span>
                            <img src="../../assets/images/dynamic_btn_praise_selected.png" />                            
                        </div>
                        <div v-else>
                            <span v-if="item.nices_num>0">{{item.nices_num}}</span>
                            <img src="../../assets/images/dynamic_btn_praise_normal.png" /> 
                        </div>                        
                    </div>
                    <div @click="upCommentbigchild" :data-toname="item.reply_name" :data-cid="item.cid" :data-uid="item.to_uid" :data-name="item.reply_name" class="article-echo-cell comment-tem-comment">
                        <img src="../../assets/images/dynamic_icon_comment.png" />                    
                    </div>                    
                </div>

                <div class="comment-tem-time">{{item.ctime}}</div>

            </div>
        </div>
    </div>
</template>

<script>
import {getnicecomment} from '../../api/api'

import Vue from "vue";
import { Toast, ImagePreview } from "vant";

Vue.use(ImagePreview);
Vue.use(Toast);
export default {
  props: ["item", "index","idx","commentList"],
  name: "comment",
  data() {
    return {
     circleidx:'',////当前动态的遍历数
    };
  },
  created(){

  },
  methods: {
    gotootherdynamic: function() {},
    upCommentbigchild: function(e) {
        this.$emit('upCommentbig',e);
    },
    showImg: function(e) {
       ImagePreview({
        images: [e.currentTarget.dataset.imgurl]
      });
    },
      //点赞和取消点赞
  gooddianzan002: function (cid, rid, idx, index) {
    var that = this;
    var show; //传递到数据库点赞的状态     
     var cookie_mid002 = this.$store.getters.DtDzShu002 || []; //获取全部点赞的mid 
    if (that.commentList[idx].reply_info[index].id == rid) { //遍历找到对应的id

      var num = that.commentList[idx].reply_info[index].nices_num; //当前赞数
      var isnice = that.commentList[idx].reply_info[index].is_nice;
      var isshow; //点赞的状态

      if (cookie_mid002.includes(rid) || isnice == 1) { //说明已经点过赞,取消赞   
        for (var j = 0; j < cookie_mid002.length; j++) {
          if (cookie_mid002[j] == rid) {
            cookie_mid002.splice(j, 1); //删除取消赞的mid 
          }
        }
        --num;
        if (num < 0) {
          num == 0
        }
        isshow = 0; //点赞的状态
        that.commentList[idx].reply_info[index].nices_num = num;
        that.commentList[idx].reply_info[index].is_nice = isshow;
        that.$store.dispatch("changeDtDzShu002Fun", cookie_mid002);
      } else {
        isshow = 1; //点赞的状态
        ++num;
        that.commentList[idx].reply_info[index].nices_num = num;
        that.commentList[idx].reply_info[index].is_nice = isshow;

        cookie_mid002.unshift(rid); //新增赞的mid
        that.$store.dispatch("changeDtDzShu002Fun", cookie_mid002);
      }
      getnicecomment(cid, rid).then(res => {
        if (res.code != 200) {
          Toast({
            message:'数据错误!',
            duration:2000
          })
        }
      })
    }
  },
    dianzanbtn002:function(e){
      var cid = e.currentTarget.dataset.cid; //此处找到列表的id
      var rid = e.currentTarget.dataset.rid;
      var index = e.currentTarget.dataset.index;
      var idx = e.currentTarget.dataset.idx //获取当前点击评论的一级评论所在遍历数
      this.circleidx = idx;
      this.gooddianzan002(cid, rid, idx, index);
    },
  }
};
</script>

<style scoped>
/* template/comment-template/comment-template.wxss */
.recomment-tem-commentbox {
  display: flex;
  flex-flow: row nowrap;
  border-bottom: 0.02702702702702703rem solid #f8f8f8;
  padding-bottom: 0.8108108108108109rem;
  padding-left: 2.1621621621621623rem;
}
.recomment-tem-commentbox .comment-tem-left {
  width: 2.2972972972972974rem;
  flex: 0 0 2.2972972972972974rem;
}
.recomment-tem-commentbox .comment-tem-left .articletx {
  padding-top: 0.8108108108108109rem;
  width: 1.0810810810810811rem;
  height: 1.0810810810810811rem;
  border-radius: 50%;
  margin: 0 auto;
}
.recomment-tem-commentbox .comment-tem-left .articletx img {
  width: 1.0810810810810811rem;
  height: 1.0810810810810811rem;
  border-radius: 50%;
}
.recomment-tem-commentbox .comment-tem-right {
  width: 15.405405405405405rem;
  padding-right: 0.6756756756756757rem;
}
.recomment-tem-commentbox .comment-tem-right .article-r-top {
  padding-top: 0.8108108108108109rem;
}
.recomment-tem-commentbox .comment-tem-right .article-r-top .article-title {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-r-top
  .article-title
  .article-to {
  width: 0.6756756756756757rem;
  height: 0.6756756756756757rem;
  margin: 0.13513513513513514rem;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-r-top
  .article-title
  .article-author {
  font-size: 0.7567567567567568rem;
  color: #333;
  font-weight: bold;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-r-top
  .article-title
  .article-time {
  padding-top: 0.13513513513513514rem;
  color: #999;
}
.recomment-tem-commentbox .comment-tem-right .article-r-top .followbtn {
  float: right;
  padding-top: 0.13513513513513514rem;
}
.recomment-tem-commentbox .comment-tem-right .article-r-top .followbtn button {
  width: 3.5135135135135136rem;
  font-size: 0.7027027027027027rem;
  height: 1.4324324324324325rem;
  background: #fff;
  border: 1px solid #ffbd0a;
  line-height: 1.3513513513513513rem;
  color: #ffbd0a;
}
.recomment-tem-commentbox .comment-tem-right .article-content {
  padding-top: 0.2702702702702703rem;
  position: relative;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-content
  .article-content-text {
  color: #333;
  font-size: 0.7567567567567568rem;
  white-space: wrap;
  text-overflow: ellipsis;
  line-height: 1.2432432432432432rem;
  word-break: break-all;
}
.recomment-tem-commentbox .comment-tem-right .article-echo {
  padding-top: 0.2702702702702703rem;
}
.recomment-tem-commentbox .comment-tem-right .article-echo .article-echo-cell {
  padding-left: 1.0810810810810811rem;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-dianping {
  float: right;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-dianping
  .comment-tem-comment {
  float: left;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-dianping
  .comment-tem-applause {
  float: left;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-dianping
  .comment-tem-applause
  span {
  padding-right: 0.21621621621621623rem;
  padding-top: 0.08108108108108109rem;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .article-echo-cell
  img {
  width: 0.8108108108108109rem;
  height: 0.8108108108108109rem;
  float: left;
  margin-top: 0.10810810810810811rem;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .article-echo-cell
  img {
  float: left;
  font-size: 0.7567567567567568rem;
  color: #333;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .article-echo-cell
  span {
  float: left;
  padding-left: 0.40540540540540543rem;
  font-size: 0.7567567567567568rem;
  color: #333;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .article-echo-cell
  span.red {
  color: #f5495a;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-comment
  img {
  width: 0.8918918918918919rem;
  height: 0.8648648648648649rem;
  float: left;
}
.recomment-tem-commentbox .comment-tem-right .article-echo .comment-tem-time {
    font-size: 0.7567567567567568rem;
  color: #999;
}
.recomment-tem-commentbox .comment-tem-right .article-content .comment-imgbox {
  padding-top: 0.6756756756756757rem;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-content
  .comment-imgbox
  .comment-imgbox-nr {
  width: 5.405405405405405rem;
}
.recomment-tem-commentbox
  .comment-tem-right
  .article-content
  .comment-imgbox
  .comment-imgbox-nr
  img {
  max-width: 5.405405405405405rem;
}
</style>


// WEBPACK FOOTER //
// src/components/public/recomment.vue